import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import Navbar   from './components/Navbar';
import Footer   from './components/Footer';

import Home       from './pages/Home';
import About      from './pages/About';
import Software   from './pages/Software';
import AppDev     from './pages/AppDev';
import Training   from './pages/Training';
import Staffing   from './pages/Staffing';
import Industries from './pages/Industries';
import Contact    from './pages/Contact';
import NotFound   from './pages/NotFound';

export default function App() {
  const { pathname } = useLocation();

  // Scroll to top on every route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/about-us"      element={<About />} />
          <Route path="/software"   element={<Software />} />
          <Route path="/services"    element={<AppDev />} />
          <Route path="/training"   element={<Training />} />
          <Route path="/staffing"   element={<Staffing />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/contact-us"    element={<Contact />} />
          <Route path="*"           element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
